import React from "react";
import "./About.css";
import AboutImg from "../../assets/about.JPG";
import Info from "./Info.jsx";
import { useSelector } from "react-redux";
import CvDownloadDropdown from "../cvDownload/CvDownloadDropdown.jsx";

const About = () => {
  const es_en = useSelector((state) => state.translation);

  return (
    <section className="about section reveal" id="about">
      <h2 className="section__title">{es_en ? "About me" : "Sobre mi"}</h2>
      <span className="section__subtitle">
        {es_en ? "My introduction" : "Introducción"}
      </span>

      <div className="about__container container grid">
        <img src={AboutImg} alt="" className="about__img" />

        <div className="about__data">
          <Info />
          <p className="about__description">
            {es_en
              ? "I specialize in Angular (v14–21), NestJS, and React ecosystems, with a strong focus on clean architectures and a DevOps mindset. My differentiator is efficiency: I use AI-assisted workflows (Orion OS, GitHub MCP) to accelerate the software lifecycle while maintaining rigorous quality standards. My background in business administration allows me to align every line of code with real business objectives. I am looking for a team where technology solves real problems and continuous innovation is valued."
              : "Me especializo en ecosistemas Angular (v14–21), NestJS y React, con un enfoque sólido en arquitecturas limpias y mentalidad DevOps. Mi diferencial es la eficiencia: utilizo flujos de trabajo asistidos por IA (Orion OS, GitHub MCP) para acelerar el ciclo de vida del software manteniendo estándares de calidad rigurosos. Mi formación en administración me permite alinear cada línea de código con los objetivos reales del negocio. Busco un equipo donde la tecnología resuelva problemas reales y se valore la innovación continua."}
          </p>

          <CvDownloadDropdown isEnglish={es_en} variant="primary" />
        </div>
      </div>
    </section>
  );
};

export default About;
